import styled from "styled-components";
import { Button } from "react-bootstrap";

export const AppButton = styled(Button)`
  color: #663300;
  background-color: transparent;
  font-family: Armata-Regular;
  letter-spacing: 1px;
  font-size: 16px;
  width: 300px;
  padding: 10px 0px;
  border-radius: 10px;
  border: 1px solid #663300;
  &:hover {
    outline: none;
    box-shadow: 0 0 3pt 2pt #663300;
    color: #ffffff;
    background-color: #663300;
    border-color: #663300 !important;
  }
  &:focus {
    outline: none;
    box-shadow: 0 0 3pt 2pt #663300;
    color: #ffffff;
    background-color: #663300;
    border-color: #663300 !important;
  }
`;
